export const styles = {
  contactsSection: {
    margin: 1,
  },
  contactAccordian: {
    bgcolor: "secondary.light",
  },
  contactDetails: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  singleContactDetails: {
    marginTop: 1,
    marginBottom: 1,

    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  formItem: {
    width: "100%",
  },
  button: {
    margin: 1,
    bgcolor: "secondary.main",
    // color: "primary.main",
    "&:hover": {
      bgcolor: "secondary.dark",
    },
  },
};
